import React, { useContext, useEffect, useState, useMemo } from 'react';
import styled from 'styled-components';

import { Typography, Space } from 'antd';
import { AssociationsSelector } from 'ui-library/components/AssociationsSelector/AssociationsSelector';
import Form from 'components/ui/Form';

import { IncentivesContext } from 'components/landlord_app/payments/LandlordIncentives';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const ErrorBorder = styled.div`
  border: ${(props) =>
    !props.disabled && props.error
      ? `1px solid ${colors.RED} !important`
      : `0px solid transparent`};
  border-radius: 1px;
`;

const Associations = ({ setFieldValue, values, errors, touched }) => {
  const incentivesData = useContext(IncentivesContext);
  const { incentiveAssociations } = incentivesData;

  const [dataSource, setDataSource] = useState([]);

  const selectedRows = useMemo(() => {
    return values.unit_ids.map((id) => `unit__${id}`);
  }, [values.unit_ids]);

  useEffect(() => {
    if (!!incentiveAssociations) {
      setDataSource(incentiveAssociations);
    }
  }, [incentiveAssociations]);

  const setSelected = (selectedRows) => {
    const unitIds = selectedRows.map((r) => r.split('__').slice(-1)).flat();
    setFieldValue('unit_ids', unitIds);
  };

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Title level={5} style={{ margin: 0 }}>
        {getTranslatedString('landlordPortal.incentives.associations')}
      </Title>
      <ErrorBorder error={touched.unit_ids && !!errors.unit_ids}>
        <Form.Item
          help={touched.unit_ids && errors.unit_ids}
          error={touched.unit_ids && errors.unit_ids}
        >
          <AssociationsSelector
            height="50vh"
            cancelAction={() => {}}
            loading={dataSource.length === 0}
            dataSource={dataSource}
            saveAction={() => {}}
            onSelection={setSelected}
            selectedRows={selectedRows}
            showExactMatchCheckbox
            asyncSave
          />
        </Form.Item>
      </ErrorBorder>
    </Space>
  );
};

export default Associations;
